import { connect } from 'react-redux'
import PostPhotoGalleryComponent from '../components/PostPhotoGalleryComponent.jsx';
import {
	forwardToExpandMenuMax,
	forwardToMarkPostPop,
	forwardToFindPostPhotos,
	forwardToDeletePhotoById
} from '../actions';

const mapStateToProps = (state) => ({
	request: state.getIn(['maintenanceAuditingReducer', 'request']),
	response: state.getIn(['maintenanceAuditingReducer', 'response']),
	options: state.getIn(['maintenanceAuditingReducer', 'options']),
	alert: state.getIn(['alertReducer', 'alert']),

	menu: state.getIn(['menuReducer', 'menu']),
})

const mapDispatchToProps = (dispatch) => ({

	expandContent: () => {
		dispatch(forwardToExpandMenuMax());
	},
	findPhotos: (card, type) => {
		dispatch(forwardToFindPostPhotos(card, type, "POST"));
	},
	pop: (dataUri) => {
		dispatch(forwardToMarkPostPop(dataUri));
	},
	deletePhotoById: (photoId, card, type, stage) => {
		dispatch(forwardToDeletePhotoById(photoId, card, type, stage));
	},
})

const PostPhotoGalleryContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(PostPhotoGalleryComponent)

export default PostPhotoGalleryContainer;


// WEBPACK FOOTER //
// ./src/containers/PostPhotoGalleryContainer.jsx